import { connect } from 'react-redux';

import EmailTemplateView from "./EmailTemplateView";
import { fetchEmailTemplates, fetchEmailTemplate, updateEmailTemplate, invalidateSelectionEmailTemplate, invalidateEmailTemplates } from 'src/legacy/redux/actions/emailTemplate.jsx'
import { showSettingsSideMenu, hideSettingsSideMenu }
  from 'src/legacy/redux/actions/settings';
import hasAccess from 'src/legacy/services/hasAccess';
import withUseHooks from 'src/legacy/components/withUseHooks';
import _ from 'lodash';

const mapStateToProps = (state, ownProps) => {
  return {
    loading: _.get(state.legacyRootReducer, "settings.emailTemplate.loading"),
    emailTemplates: _.get(state.legacyRootReducer, "settings.emailTemplate.items"),
    hasMore: _.get(state.legacyRootReducer, "settings.emailTemplate.loadMore"),
    showSettingsMenu: _.get(state.legacyRootReducer, "settings.settingsMenu.showSettingsMenu")
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    showSettingsSideMenu: () => {
      return dispatch(showSettingsSideMenu());
    },
    hideSettingsSideMenu : () => {
        return dispatch(hideSettingsSideMenu())
    },
    fetchEmailTemplates: (query, page) => {
        return dispatch(fetchEmailTemplates(query, page));
    },
    fetchEmailTemplate: (id) => {
      return dispatch(fetchEmailTemplate(id))
    },
    updateEmailTemplate: (id, emailTemplate) => {
      return dispatch(updateEmailTemplate(id, emailTemplate));
    },
    invalidateSelectionEmailTemplate: () => {
      return dispatch(invalidateSelectionEmailTemplate());
    },
    invalidateEmailTemplates:() => {
      return dispatch(invalidateEmailTemplates());
    }
  }
}

const 
EmailTemplatePage = connect (
    mapStateToProps,
    mapDispatchToProps
)(EmailTemplateView);

// export default hasAccess(EmailTemplatePage,'email-template');
export default withUseHooks(EmailTemplatePage);